/* ============================================================
   TAPA — Free Gifts Auto-Add (v2, tracking-safe)
   Cuando el strap entra al carrito, los 3 regalos se añaden
   automáticamente. Si el strap sale del carrito, los regalos
   se quitan solos. Sin apps, sin descuentos extra.

   v3: la petición /cart/add del tema viaja INTACTA byte a byte
   (así Shopify y Meta emiten el evento AddToCart). Para que en el
   drawer el strap quede ARRIBA y los regalos DEBAJO, los regalos
   entran PRIMERO con una llamada aparte a /cart/add.js y solo
   después se deja pasar la petición original del tema (retraso
   ~300ms, cero modificación).

   CONFIGURA AQUÍ (handles = el slug de la URL del producto):
   ============================================================ */
(function () {
  var CONFIG = {
    strapHandle: 'tapa-precision-strap',
    giftHandles: [
      '5-moves-for-knees-that-jab-ebook',
      'placement-guide',
      'the-60-day-stairs-test'
    ]
  };

  var giftVariantIds = null;
  var strapVariantIds = null;

  function fetchJSON(url, opts) {
    /* usa window.fetch actual para que otras capas (drawer apps) vean los updates */
    return window.fetch(url, opts).then(function (r) { return r.ok ? r.json() : null; });
  }

  function resolveProduct(handle) {
    return fetchJSON('/products/' + handle + '.js').then(function (p) {
      return p ? p.variants.map(function (v) { return v.id; }) : [];
    }).catch(function () { return []; });
  }

  function resolveAll() {
    if (giftVariantIds && strapVariantIds) return Promise.resolve();
    var gifts = Promise.all(CONFIG.giftHandles.map(resolveProduct)).then(function (lists) {
      giftVariantIds = lists.map(function (l) { return l[0]; }).filter(Boolean);
    });
    var strap = resolveProduct(CONFIG.strapHandle).then(function (ids) {
      strapVariantIds = ids;
    });
    return Promise.all([gifts, strap]);
  }

  function getCart() { return fetchJSON('/cart.js'); }

  function cartHasStrap(cart) {
    return cart.items.some(function (it) { return it.handle === CONFIG.strapHandle; });
  }

  function missingGifts(cart) {
    var inCart = cart.items.map(function (it) { return it.variant_id; });
    return giftVariantIds.filter(function (id) { return inCart.indexOf(id) === -1; });
  }

  function orphanGifts(cart) {
    var updates = {};
    cart.items.forEach(function (it) {
      if (giftVariantIds.indexOf(it.variant_id) !== -1) updates[it.variant_id] = 0;
    });
    return updates;
  }

  function extraGiftQty(cart) {
    var updates = {};
    cart.items.forEach(function (it) {
      if (giftVariantIds.indexOf(it.variant_id) !== -1 && it.quantity > 1) updates[it.variant_id] = 1;
    });
    return updates;
  }

  function addItems(variantIds) {
    if (!variantIds.length) return Promise.resolve(null);
    /* /cart/add.js en llamada APARTE: el add principal del tema ya viajó
       intacto y su evento AddToCart ya se emitió. */
    return fetchJSON('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: variantIds.map(function (id) { return { id: id, quantity: 1 }; }) })
    });
  }

  function applyUpdates(updates) {
    if (!Object.keys(updates).length) return Promise.resolve(null);
    /* /cart/update.js añade los items que falten y ajusta cantidades,
       sin contar como "add to cart" en analytics: cero ruido. */
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  /* --- Detección PASIVA del add del strap (no toca la petición) --- */
  function bodyLooksLikeStrapAdd(init) {
    return resolveAll().then(function () {
      if (!init || !init.body || !strapVariantIds || !strapVariantIds.length) return false;
      var ids = [];
      var body = init.body;
      if (body instanceof FormData) {
        body.forEach(function (val, key) {
          if (key === 'id' || key === 'items[0][id]') ids.push(parseInt(val, 10));
        });
      } else if (typeof body === 'string') {
        try {
          var json = JSON.parse(body);
          if (json.id) ids.push(parseInt(json.id, 10));
          (json.items || []).forEach(function (it) { ids.push(parseInt(it.id, 10)); });
        } catch (e) { /* body no-JSON: lo ignoramos */ }
      }
      return ids.some(function (id) { return strapVariantIds.indexOf(id) !== -1; });
    }).catch(function () { return false; });
  }

  /* Añade los regalos que falten. skipStrapCheck=true cuando se llama
     ANTES del add principal (el strap aún no está en el carrito). */
  function addGiftsIfMissing(skipStrapCheck) {
    return resolveAll().then(function () {
      if (!giftVariantIds || !giftVariantIds.length) return;
      return getCart().then(function (cart) {
        if (!cart) return;
        if (!skipStrapCheck && !cartHasStrap(cart)) return;
        return addItems(missingGifts(cart)).then(function (changed) {
          if (changed) document.dispatchEvent(new CustomEvent('tapa:gifts-added'));
        });
      });
    });
  }

  /* --- Vigilancia: quita regalos huérfanos y corrige cantidades --- */
  function reconcile() {
    resolveAll().then(function () {
      if (!giftVariantIds || !giftVariantIds.length) return;
      getCart().then(function (cart) {
        if (!cart || !cart.items.length) return;
        var updates = cartHasStrap(cart) ? extraGiftQty(cart) : orphanGifts(cart);
        applyUpdates(updates).then(function (changed) {
          if (changed && location.pathname === '/cart') location.reload();
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reconcile);
  else reconcile();

  /* --- ÚNICO hook de fetch, 100% pasivo: llama SIEMPRE con los
     argumentos originales intactos y solo REACCIONA a la respuesta. --- */
  var passthrough = window.fetch.bind(window);
  var addingGifts = false; /* nuestras propias llamadas no se re-interceptan */

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var args = arguments;
    var self = window;

    if (url.indexOf('/cart/add') !== -1 && !addingGifts) {
      var initRef = init || (typeof input === 'object' ? input : null);
      /* ¿Es el add del strap? Entonces: regalos primero, strap después
         (el último en entrar sale ARRIBA en el drawer). La petición del
         tema se retrasa unos ms pero se envía INTACTA. */
      var p = bodyLooksLikeStrapAdd(initRef).then(function (isStrap) {
        if (!isStrap) return passthrough.apply(self, args);
        addingGifts = true;
        return addGiftsIfMissing(true)
          .catch(function () {})
          .then(function () {
            addingGifts = false;
            return passthrough.apply(self, args);
          });
      }).catch(function () {
        addingGifts = false;
        return passthrough.apply(self, args);
      });
      /* Red de seguridad: si el pre-add falló, reintenta tras la respuesta */
      p.then(function (res) {
        if (res && res.ok) setTimeout(function () { addGiftsIfMissing(false); }, 300);
      }).catch(function () {});
      return p;
    }

    var q = passthrough.apply(self, args);
    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
      q.then(function () { setTimeout(reconcile, 400); }).catch(function () {});
    }
    return q;
  };
})();
